import * as React from 'react';
import { SubStep } from 'common/onboarding/immersive-onboarding-legacy/types';
import { ScrollableElement } from 'common/onboarding/immersive-onboarding-legacy/components/scroll-manager';
import { HeaderProps, SectionProps } from '../events/types';
import { EventSubStepContext } from '../events/common';
import { SectionContent } from './section-content';
export const Section = (props: React.PropsWithChildren<HeaderProps & SectionProps & {
  spyCallback?: () => void;
  active?: boolean;
}>) => {
  const {
    eventSubStep: currentSubStep
  } = React.useContext(EventSubStepContext);
  if (props.scrollable) {
    // SubStep is a string enum; need to check ordering of the Enum object
    const subStepIndex = Object.values(SubStep).indexOf(props.subStepId);
    const curIndex = Object.values(SubStep).indexOf(currentSubStep);
    return <ScrollableElement name={props.subStepId} active={props.active !== null ? props.active : subStepIndex <= curIndex} viewSpy spyCallback={props.spyCallback}>
        <SectionContent {...props} />
      </ScrollableElement>;
  }
  return <SectionContent {...props} data-sentry-element="SectionContent" data-sentry-component="Section" data-sentry-source-file="section.tsx" />;
};